// extracted by mini-css-extract-plugin
export default {"NotificationModalContainer":"styles_NotificationModalContainer__dfVPQ","showTop":"styles_showTop__w50uP"};